<template>
    <section class="pt-4 space-y-5 sm:space-y-8 px-14 sm-max:px-5 lg:space-y-12 md:pb-14 md:pt-7 pb-7">
      <h3 class="font-bold text-center md-max:px-2 lg:text-34 xl:text-4xl md:text-32 text-22 leading-head md-max:pb-4 sm-max:text-21 lg:px-24 xl:px-40" v-html="title">
      </h3>
  
      <div class="grid grid-cols-1 px-7 md:grid-cols-2 lg:px-10 md:gap-x-10 lg:gap-x-14 gap-y-2 md:gap-y-1">
        <ul class="grid list-disc gap-y-2 xl:gap-y-6 lg:gap-y-4">
          <li v-for="(point, index) in pointsLeft" :key="index" class="text-lg sm:text-xl xl:text-32 md:text-2xl">
            {{ point }}
          </li>
        </ul>
        <ul class="grid list-disc gap-y-2 xl:gap-y-6 lg:gap-y-4">
          <li v-for="(point, index) in pointsRight" :key="index" class="text-lg sm:text-xl xl:text-32 md:text-2xl">
            {{ point }}
          </li>
        </ul>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    title: {
      type: String,
      default: "And that’s not all. This coffee includes all of the above qualities and more:",
    },
    pointsLeft: {
      type: Array,
      default: () => [
        "One Pure Ingredient",
        "Single Origin",
        "Shade Grown",
        "Pure, Clean Ingredients"
      ]
    },
    pointsRight: {
      type: Array,
      default: () => [
        "High-Elevation Grown",
        "Sun-Dried",
        "Specialty Beans",
        "Fairly traded"
      ]
    }
  });
  
  defineBuilderComponent({
    friendlyName: "TitleWithPoints",
    canHaveChildren: false,
    inputs: [
      {
        name: "title",
        type: "richText",
        defaultValue: "And that’s not all. This coffee includes all of the above qualities and more:"
      },
      {
        name: "pointsLeft",
        type: "list",
        defaultValue: [
          "One Pure Ingredient",
          "Single Origin",
          "Shade Grown",
          "Pure, Clean Ingredients"
        ],
        subFields: [
          {
            name: "point",
            type: "text",
            defaultValue: "Point"
          }
        ]
      },
      {
        name: "pointsRight",
        type: "list",
        defaultValue: [
          "High-Elevation Grown",
          "Sun-Dried",
          "Specialty Beans",
          "Fairly traded"
        ],
        subFields: [
          {
            name: "point",
            type: "text",
            defaultValue: "Point"
          }
        ]
      }
    ]
  });
  </script>